import {z} from 'zod'

export enum SpecificationKey {
    WITHDRAWAL,
    ADJUSTMENT,
    REVERSAL,
    LOSS_OF_CLAIMS
}

export const VatOptionSchema = z.object({
    id: z.number(),
    code: z.number(),
    activeFrom: z.string(),
    activeTo: z.string(),
    rate: z.number(),
    displayedRate: z.number(),
    specificationKey: z.enum(SpecificationKey).optional(),
    name: z.string(),
    exclusive: z.boolean()
})

export type VatOption = z.infer<typeof VatOptionSchema>

/* TODO: How can we avoid hard-coding these options? */
//TODO: targetAccounts not in type. Should they be?
export const defaultVatOption = {
    id: 1,
    code: 0,
    displayedRate: 0,
    rate: 0,
    activeFrom: '2022-01-01',
    activeTo: '2099-12-31',
    targetAccounts: [],
    name: 'Ingen mva',
    exclusive: false
}

export const defaultIncomeVatOption = {
    id: 16,
    code: 3,
    displayedRate: 0.25,
    rate: 0.25,
    activeFrom: '2000-01-01',
    activeTo: '2099-12-31',
    targetAccounts: [],
    name: 'Salg av varer og tjenester',
    exclusive: false
}

